"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import Link from "@/components/ui/Link";
import { getTimeAgo } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  slug?: string;
};
export const VerticalMediumDescNews = t0 => {
  const $ = _c(38);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    slug
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BC7.\u0B8E\u0BB2\u0BCD.\u0BB0\u0BBE\u0B95\u0BC1\u0BB2\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF\u0B95\u0BB0\u0BAE\u0BBE\u0BA9 \u0B85\u0BB1\u0BC1\u0BB5\u0BC8 \u0B9A\u0BBF\u0B95\u0BBF\u0B9A\u0BCD\u0B9A\u0BC8 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0B85\u0BB5\u0BB0\u0BCD \u0BA4\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF \u0BB5\u0BB0\u0BC1\u0BB5\u0BA4\u0BBF\u0BB2\u0BCD \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE\u0B95",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const title = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "\u0BA4\u0BBE\u0BB0\u0B95\u0BCD \u0BAE\u0BC7\u0BA4\u0BCD\u0BA4\u0BBE \u0B95\u0BBE \u0B8A\u0BB2\u0BCD\u0BA4\u0BBE \u0B9A\u0BBE\u0BB7\u0BCD\u0BAE\u0BBE \u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BA9\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BBE\u0BB3\u0BB0\u0BCD \u0B85\u0B9A\u0BBF\u0BA4\u0BCD \u0B95\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD \u0BAE\u0BCB\u0B9F\u0BBF \u0B9A\u0BAE\u0BC0\u0BAA \u0B95\u0BBE\u0BB2\u0BAE\u0BBE\u0B95 \u0BAA\u0BB2 \u0B95\u0BC1\u0BB1\u0BCD\u0BB1\u0B9A\u0BCD\u0B9A\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC8 \u0B9A\u0BA8\u0BCD\u0BA4\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 \u0BB5\u0BB0\u0BC1\u0B95\u0BBF\u0BB1\u0BBE\u0BB0\u0BCD. \u0B9C\u0BC6\u0BA9\u0BBF\u0BAA\u0BB0\u0BCD \u0BAE\u0BBF\u0BB8\u0BCD\u0BA4\u0BBF\u0BB0\u0BBF",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const excerpt = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const timeAgo = t6;
  useRouter();
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t7 = timeAgo?.value;
  let t8;
  if ($[6] !== t7) {
    t8 = getTimeAgo(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const timeAgoValue = t8;
  const t9 = `/${slug}`;
  const t10 = `flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4 ${slug ? "cursor-pointer" : ""}`;
  let t11;
  if ($[8] !== title?.customClass || $[9] !== title?.hidden || $[10] !== titleValue) {
    t11 = !title?.hidden && <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[8] = title?.customClass;
    $[9] = title?.hidden;
    $[10] = titleValue;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== excerpt?.customClass || $[13] !== excerpt?.hidden || $[14] !== excerptValue) {
    t12 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D leading-relaxed line-clamp-4 h-auto ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[12] = excerpt?.customClass;
    $[13] = excerpt?.hidden;
    $[14] = excerptValue;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== timeAgo?.customClass || $[17] !== timeAgo?.hidden || $[18] !== timeAgoValue) {
    t13 = !timeAgo?.hidden && <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[16] = timeAgo?.customClass;
    $[17] = timeAgo?.hidden;
    $[18] = timeAgoValue;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const t14 = slug ? `/${slug}` : undefined;
  let t15;
  if ($[20] !== excerptValue || $[21] !== slug || $[22] !== t14 || $[23] !== titleValue) {
    t15 = <div className="flex gap-3" onClick={_temp}><MessageIcon id="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} description={excerptValue} articleUrl={t14} /></div>;
    $[20] = excerptValue;
    $[21] = slug;
    $[22] = t14;
    $[23] = titleValue;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <div className="flex justify-between items-center gap-3">{t13}{t15}</div>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t16) {
    t17 = <div className="flex flex-col gap-3">{t11}{t12}{t16}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t10 || $[33] !== t17) {
    t18 = <div className={t10}>{t17}</div>;
    $[32] = t10;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18 || $[36] !== t9) {
    t19 = <Link href={t9} className="block  transition-colors cursor-pointer">{t18}</Link>;
    $[35] = t18;
    $[36] = t9;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
};
function _temp(e) {
  return e.stopPropagation();
}